import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';

const StyledLink = ({ children, href, link, className, ...props }) => {
  const theClasses = clsx('font-medium underline transition duration-200 text-white hover:opacity-75', className);

  if (link) {
    return (
      <Link href={href}>
        <a className={theClasses} {...props}>
          {children}
        </a>
      </Link>
    );
  }

  return (
    <a href={href} className={theClasses} {...props}>
      {children}
    </a>
  );
};

export default StyledLink;
